export default {
  sidebar: {
    title: 'Merchant Cabinet',
    transactions: 'Transactions',
    payout: 'Payout',
  },
  settings: {
    logout: 'Logout',
  },
  transactions: {
    pageSize: 'Page size',
    datePlaceholder: 'Select date',
    exportPage: 'Export page',
    transactionInfo: 'Transaction info',
    of: 'of',
    columns: {
      description: 'Description',
      transactionType: 'Transaction type',
      status: 'Status',
      statusDescription: 'Status description',
      merchantId: 'Merchant ID',
      merchantName: 'Merchant name',
      serviceId: 'Service ID',
      serviceName: 'Service name',
      agent: 'Agent',
      payGateCommission: 'Commission',
      serviceCommission: 'Service commission',
      amount: 'Amount',
      phone: 'Phone number',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
    },
    modal: {
      description: 'Payment description',
      transactionType: 'Transaction type',
      status: 'Status',
      statusDescription: 'Status description',
      merchantId: 'Merchant ID',
      merchantName: 'Merchant name',
      serviceId: 'Service ID',
      serviceName: 'Service name',
      agent: 'Agent',
      payGateCommission: 'Commission',
      serviceCommission: 'Service commission',
      amount: 'Amount',
      phone: 'Phone number',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
    },
  },
  payout: {
    pageSize: 'Page size',
    datePlaceholder: 'Select date',
    exportPage: 'Export page',
    transactionInfo: 'Transaction info',
    of: 'of',
    columns: {
      creditAmount: 'Credit amount',
      totalAmount: 'Total amount',
      cardNumber: 'Card number',
      externalId: 'External ID',
      statusDescription: 'Status description',
      status: 'Status',
      createdAt: 'Created at',
      finishedAt: 'Finished at',
    },
    modal: {
      description: 'Payment description',
      transactionType: 'Transaction type',
      status: 'Status',
      statusDescription: 'Status description',
      merchantId: 'Merchant ID',
      merchantName: 'Merchant name',
      serviceId: 'Service ID',
      serviceName: 'Service name',
      agent: 'Agent',
      payGateCommission: 'Commission',
      serviceCommission: 'Service commission',
      amount: 'Amount',
      phone: 'Phone number',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
    },
  },
  errors: {
    error: 'Error',
  },
}
